// extracted by mini-css-extract-plugin
export default {"title":"saleSlider_title__Ek8Bl"};